<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Modal from 'dashboard/components/Modal.vue';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  show: Boolean,
  instance: Object,
  accountId: [String, Number]
});

const emit = defineEmits(['close']);

const qrCodeBase64 = ref('');
const loading = ref(true);
let pollingInterval = null;

const fetchQrCode = async () => {
  loading.value = true;
  try {
    const response = await window.axios.get(`/api/v1/accounts/${props.accountId}/evolution/${props.instance.name}/connect`);
    qrCodeBase64.value = response.data.base64;
  } catch (error) {
    useAlert('Erro ao buscar o QR Code');
    emit('close');
  } finally {
    loading.value = false;
  }
};

const checkStatus = async () => {
  try {
    const response = await window.axios.get(`/api/v1/accounts/${props.accountId}/evolution`);
    
    // Find instance using the flexible matching logic used elsewhere
    const currentInstance = response.data.find(i => (i.instance?.instanceName || i.name || i.instanceName) === props.instance.name);
    
    if (currentInstance && currentInstance.connectionStatus === 'open') {
      // Configure Chatwoot integration only AFTER it's fully connected
      await window.axios.post(`/api/v1/accounts/${props.accountId}/evolution/${props.instance.name}/configure_integration`);
      
      useAlert('Conexão estabelecida com sucesso!');
      emit('close');
    }
  } catch (error) {
    // Ignore error in polling
  }
};

onMounted(() => {
  fetchQrCode();
  pollingInterval = setInterval(checkStatus, 5000); // Check status every 5s
});

onUnmounted(() => {
  if (pollingInterval) clearInterval(pollingInterval);
});
</script>

<template>
  <Modal :show="show" :on-close="() => emit('close')">
    <div class="flex flex-col p-6 items-center max-w-md w-full mx-auto">
      <h2 class="text-xl font-bold text-n-slate-12 mb-2">Conectar Aparelho</h2>
      <p class="text-sm text-n-slate-11 text-center mb-6">
        Abra o WhatsApp no seu celular, vá em Aparelhos Conectados e escaneie o código abaixo.
      </p>

      <div class="bg-white p-4 rounded-xl border border-n-slate-3 flex justify-center items-center min-h-[250px] min-w-[250px]">
        <div v-if="loading" class="animate-spin rounded-full h-8 w-8 border-b-2 border-n-slate-12"></div>
        <img v-else-if="qrCodeBase64" :src="qrCodeBase64" alt="QR Code" class="w-full max-w-[250px]" />
        <div v-else class="text-n-slate-11 text-sm text-center">QR Code não disponível. Verifique se o painel do Evolution está respondendo.</div>
      </div>

      <button @click="emit('close')" class="mt-8 px-6 py-2 bg-n-slate-3 hover:bg-n-slate-4 text-n-slate-11 rounded font-medium transition-colors">
        Cancelar
      </button>
    </div>
  </Modal>
</template>
